import { render, staticRenderFns } from "./EditOcrText.vue?vue&type=template&id=5597c990&lang=pug"
import script from "./EditOcrText.vue?vue&type=script&lang=js"
export * from "./EditOcrText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports